import React, { Component } from 'react';
import DateTime from 'react-datetime';

import './../../../node_modules/react-datetime/css/react-datetime.css';

class RelationForm extends Component
{
    constructor(props)
    {
        super(props);

        this.onChange = props.onChange;
        
        this.handeInput = this.handeInput.bind(this);
        this.handleDate = this.handleDate.bind(this);

        this.DateTime = React.createRef();
        this.DateTimeUpdate = React.createRef();
    }

    handeInput(event)
    {
        let value = event.target.type === 'checkbox' ? (event.target.checked === true ? 1 : 0) : event.target.value;
        let evt = {
            "target" : {
                "name" : event.target.name,
                "value" : value
            } 
        }
        
        this.onChange(evt);
    }

    handleDate(ref, name, date)
    {
        ref.current.querySelector('.text-danger').style.display = "none";
        ref.current.querySelector('.rdt .form-control').classList.remove("invalid")
        if(date._isAMomentObject == null)
        {
            ref.current.querySelector('.text-danger').style.display = "initial";
            ref.current.querySelector('.rdt .form-control').classList.add("invalid");
            let evt = {
                "target" : {
                    "name" : name,
                    "value" : null
                } 
            }
            this.onChange(evt);
            return;
        }
        else
        {
            let evt = {
                "target" : {
                    "name" : name,
                    "value" : date.unix()
                } 
            }
            this.onChange(evt);
        }
    }

    render()
    {
        return (
            <div className="fade modal show" id="addRelationModal" tabIndex="-1" role="dialog" aria-labelledby="addRelationModalLabel" aria-modal="true">
            <div className="modal-dialog modal-full-height modal-right" role="document">
                <div className="modal-content rounded-0 p-3">
                    <button type="button" className="close closeSideModal" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                    <div className="modal-header">
                        <h4 className="modal-title" id="addRelationModalLabel">Ajouter une relation</h4>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Nature
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="nature" value={ this.props.relation.nature } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 100 caractères.
                                    </small>
                                </div>
                            
                                <div className="form-group" ref={ this.DateTime }>
                                    <label className="h5 font-weight-bold">
                                        Date
                                    </label>
                                    <DateTime name="date" timeFormat={ false } onChange={ (date) => { this.handleDate(this.DateTime, "date", date)  } } dateFormat="DD/MM/YYYY" value={ this.props.relation.date != null ? this.props.relation.date*1000 : null } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir une date valide
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Conseiller
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="conseilor" value={ this.props.relation.conseilor } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 100 caractères.
                                    </small>
                                </div>
                            
                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Canal
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="canal" value={ this.props.relation.canal } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 100 caractères.
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Type
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="type" value={ this.props.relation.type } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 100 caractères.
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Type d'intérêt
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="interest" value={ this.props.relation.interest } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 100 caractères.
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Sous-type d'intérêt
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="under_interest" value={ this.props.relation.under_interest } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 100 caractères.
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Avancement
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="progress" value={ this.props.relation.progress } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 100 caractères.
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Nom Affaire
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="shortname" value={ this.props.relation.shortname } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 100 caractères.
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Commentaire
                                    </label>
                                    <textarea type="text" maxLength="400" className="form-control" name="comment" value={ this.props.relation.comment } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 400 caractères.
                                    </small>
                                </div>

                                <div className="form-group" ref={ this.DateTimeUpdate }>
                                    <label className="h5 font-weight-bold">
                                        Date de dernière modification
                                    </label>
                                    <DateTime name="date_last_update" timeFormat={ false } onChange={ (date_last_update) => { this.handleDate(this.DateTimeUpdate, "date_last_update", date_last_update)  } } dateFormat="DD/MM/YYYY" value={ this.props.relation.date_last_update != null ? this.props.relation.date_last_update*1000 : null } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir une date valide
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className='btn btn-primary float-right' onClick={()=> this.props.onSubmit()}>
                            <li className='fas fa-save'> </li> Enregistrer
                        </button>
                    </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RelationForm;



// WEBPACK FOOTER //
// ./src/Components/Relation/RelationForm.js